import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import PayverseHeader from '../PayverseHeader';
import { useTranslation } from 'react-i18next';
import ApiLoading from '../APILoading';
import { useGlobal } from 'global_state/useGlobal';

const Payment = () => {
  const { t, i18n } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);
  const { globalDispatch, globalState } = useGlobal();

  useEffect(() => {
    if (globalState.loading) {
      setLoading(globalState.loading);
    }
  }, [globalState.loading]);

  return (
    <div className="payverse-wrap">
      <div className="payverse">
        <PayverseHeader />
        {loading ? <ApiLoading /> : <Outlet />}
        <div className="d-section">
          <div className="box">
            <div className="copy">
              Copyright (c) eromnet Co., Ltd. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PayverseWrapper = styled.div`
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0;
  background: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
  z-index: 5000;
`;

const Payverse = styled.div<{ height: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 580px;
  height: 650px;
  margin: 0;
  padding: 0;
  background: #fff;
  box-sizing: border-box;

  @media only screen and (max-width: 767px) {
    width: calc(100% - 20px);
    height: ${props => props.height - 20};
    margin: 0;
    overflow: hidden;
  }
`;

export default Payment;
